import { useState } from "react";
import { characterTabs } from "@/mocks/character";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function CharacterSection() {
  const [active, setActive] = useState(characterTabs[0].key);
  const current = characterTabs.find((t) => t.key === active) ?? characterTabs[0];

  return (
    <section id="character" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="潘金莲电影角色分析"
            title="同一个潘金莲，四个理解角度"
            desc="角色分析不是给她定案，而是换几个视角重新看待她。切换下面的标签，可以从动机、处境、符号化与女性视角四个方向理解她。"
          />
        </Reveal>

        <Reveal className="mt-8">
          <div
            className="inline-flex flex-wrap items-center gap-1 rounded-full border border-background-300 bg-background-100 p-1"
            role="tablist"
            aria-label="角色分析视角"
          >
            {characterTabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={active === tab.key}
                onClick={() => setActive(tab.key)}
                className={`rounded-full px-4 py-1.5 font-label text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  active === tab.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-200"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <Reveal className="lg:col-span-5">
            <div className="relative w-full h-[300px] md:h-[460px] lg:h-full lg:min-h-[440px] rounded-lg overflow-hidden bg-secondary-100">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20side%20profile%20silhouette%20of%20a%20classical%20Chinese%20woman%20in%20elegant%20hanfu%20with%20hairpin%2C%20ink-wash%20splashes%2C%20deep%20crimson%20background%2C%20glowing%20gold%20accents%2C%20dramatic%20chiaroscuro%20lighting%2C%20stylized%20illustration%2C%20melancholic%20mood&width=800&height=1000&seq=panjinlian-char&orientation=portrait"
                alt="水墨与光影风格中身着汉服的女性侧影，用于角色分析配图"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7">
            <div className="h-full rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="flex items-center gap-2">
                <span className="h-1.5 w-8 rounded-full bg-accent-500"></span>
                <span className="font-label text-xs tracking-widest text-secondary-700 uppercase">
                  {current.label}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
                {current.title}
              </h3>

              <div className="mt-5 space-y-4">
                {current.paragraphs.map((p) => (
                  <p key={p} className="text-sm md:text-[15px] leading-relaxed text-foreground-700">
                    {p}
                  </p>
                ))}
              </div>

              <ul className="mt-6 flex flex-wrap gap-2">
                {current.points.map((point) => (
                  <li
                    key={point}
                    className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1.5 font-label text-xs text-secondary-900"
                  >
                    <i className="ri-focus-3-line"></i>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}